import styled, { keyframes } from 'styled-components';

const keyFrameRing = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const LoaderWrapper = styled.div.attrs({ 'data-testid': 'loading-spinner' })`
  display: inline-block;
  position: relative;
  width: ${({ size }) => size === 'small' ? '30px' : '40px'};
  height: ${({ size }) => size === 'small' ? '30px' : '40px'};
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${({ size }) => size === 'small' ? '20px' : '40px'};
    height: ${({ size }) => size === 'small' ? '20px' : '40px'};
    margin: 0 5px;
    border: 2px solid ${({color}) => color || '#fff'};
    border-radius: 50%;
    animation: ${keyFrameRing} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({color}) => color || '#fff'} transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
`;

export const LoaderWrapperOverlay = styled.div.attrs({ 'data-testid': 'loading-spinner' })`
  display: inline-block;
  position: absolute;
  width: ${({ size }) => (size === "small" ? "30px" : "40px")};
  height: ${({ size }) => (size === "small" ? "30px" : "40px")};
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${({ size }) => (size === "small" ? "20px" : "40px")};
    height: ${({ size }) => (size === "small" ? "20px" : "40px")};
    margin: 0 5px;
    border: 2px solid ${({ color }) => color || "#fff"};
    border-radius: 50%;
    animation: ${keyFrameRing} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ color }) => color || "#fff"} transparent transparent
      transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
`;

export const LoaderOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgb(255,255,255,0.6);
  z-index: 10000;
`;
